var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export const Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-c2ejw4-0"
})(["display:flex;flex-flow:column;"]);
export const SectionTitle = styled.h6.withConfig({
  displayName: "partials__SectionTitle",
  componentId: "sc-c2ejw4-1"
})(["position:relative;padding:6px 0 8px;margin-bottom:16px;font-size:16px;font-weight:700;line-height:24px;color:", ";height:38px;&:after{display:block;position:absolute;bottom:0;width:100%;", " ", " padding-right:16px;height:1px;content:'';background-color:", ";}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.terciaryD;
}, _ref2 => {
  let {
    longbar,
    lastitem
  } = _ref2;
  return longbar === 'true' && !lastitem ? 'width: 150%;' : '';
}, minMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), _ref3 => {
  let {
    longbar
  } = _ref3;
  return longbar === 'true' ? 'width: 150%;' : '';
}), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.ui;
});
export const StorefrontLink = styled(AppLink).withConfig({
  displayName: "partials__StorefrontLink",
  componentId: "sc-c2ejw4-2"
})(["display:block;padding:6px 0;margin:6px 0;cursor:pointer;font-size:16px;font-weight:400;line-height:24px;color:", ";", ";"], _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.fontL;
}, maxMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 15px;\n    line-height: 17px;\n  "]))));
export const MenuItemLi = styled.li.withConfig({
  displayName: "partials__MenuItemLi",
  componentId: "sc-c2ejw4-3"
})(["&:hover{a{opacity:1;color:#03f;}}"]);